export function ReturnName(cod) {
  switch (cod) {
    case "COP":
      return "PESO COLOMBIANO";

    case "DKK":
      return "COROA DINAMARQUESA";

    case "ZAR":
      return "RAND SUL-AFRICANO";

    case "CAD":
      return "DÓLAR CANADENSE";

    case "ILS":
      return "SHEKEL ISRAELENSE";

    case "RUB":
      return "RUBLO RUSSO";

    case "XAUUSD":
      return "OURO / ONÇA TROY 31.104";

    case "CHF":
      return "FRANCO SUIÇO";

    case "CNY":
      return "IUAN CHINÊS";

    case "GBP":
      return "LIBRA ESTERLINA";

    case "AED":
      return "DIRHAM DOS EMIRADOS ÁRABES";

    case "CLP":
      return "PESO CHILENO";

    case "AUD":
      return "DÓLAR AUSTRALIANO";

    case "ARS":
      return "PESO ARGENTINO";

    case "EUR":
      return "EURO";

    case "NZD":
      return "DÓLAR NEOZELANDÊS";

    case "MXN":
      return "PESO MEXICANO";

    case "SEK":
      return "COROA SUECA";

    case "JPY":
      return "IENE JAPONÊS";

    case "PEN":
      return "SOL PERUANO";

    case "OZ1D":
      return "OURO / BM&F (250g)";

    case "UYU":
      return "PESO URUGUAIO";

    case "EUSCOM":
      return "DÓLAR AMERICANO";
    case "USD":
      return "DÓLAR AMERICANO";

    case "NOK":
      return "COROA NORUEGUESA";

    case "MNG":
        return "MONEYGRAM";

    default:
      return null;
  }
}

export function ReturnNameGold(cod) {
  switch (cod) {
    case "OURO BARRA (1g)":
      return "1 grama";
    case "OURO BARRA (2g)":
      return "2 gramas";
    case "OURO BARRA (5g)":
      return "5 gramas";
    case "OURO BARRA (7g)":
      return "7 gramas";
    case "OURO BARRA (10g)":
      return "10 gramas";
    case "OURO BARRA (25g)":
      return "25 gramas";
    case "OURO BARRA (31,104g)":
      return "31,104 gramas / Onça Troy";
    case "OURO BARRA (50g)":
      return "50 gramas";
    case "OURO BARRA (100g)":
      return "100 gramas";
    case "OURO BARRA (250g)":
      return "250 gramas";
    case "OURO BARRA (500g)":
      return "500 gramas";
    case "OURO BARRA (1000g)":
      return "1000 gramas / 1kg";

    default:
      return null;
  }
}

export function ReturnGrammage(index) {
  switch (index) {
    case 0:
      return "1";
    case 1:
      return "2";
    case 2:
      return "5";
    case 3:
      return "7";
    case 4:
      return "10";
    case 5:
      return "25";
    case 6:
      return "31,104";
    case 7:
      return "50";
    case 8:
      return "100";
    case 9:
      return "250";
    case 10:
      return "500";
    case 11:
      return "1000";

      default:
        return null;
  }
}

export function ReturnGrammageGold(cod) {
  switch (cod) {
    case "OURO BARRA (1g)":
      return "1g";
    case "OURO BARRA (2g)":
      return "2g";
    case "OURO BARRA (5g)":
      return "5g";
    case "OURO BARRA (7g)":
      return "7g";
    case "OURO BARRA (10g)":
      return "10g";
    case "OURO BARRA (25g)":
      return "25g";
    case "OURO BARRA (31,104g)":
      return "31,104g";
    case "OURO BARRA (50g)":
      return "50g";
    case "OURO BARRA (100g)":
      return "100g";
    case "OURO BARRA (250g)":
      return "250g";
    case "OURO BARRA (500g)":
      return "500g";
    case "OURO BARRA (1000g)":
      return "1000g";

      default:
        return null;
  }
}

export function ReturnNamePage(name) {
  switch (name) {
    case "existentes":
      return "Barra de Ouro";
    case "1g-2g":
      return "Barra de Ouro";
    case "5g-10kg":
      return "Barra de Ouro";
    case "100g-1kg":
      return "Barra de Ouro";
    case "piramide-ouro":
      return "Pirâmide de Ouro";
    case "plante-arvore":
      return "Plante Árvore";
    case "amiga":
      return "Amiga de Ouro";
    case "amigo":
      return "Amigo de Ouro";
    case "moedas-estrangeiras":
      return "Moedas Estrangeiras";
    case "cartao-pre-pago":
      return "Cartão Pré-pago";
    case "pai":
      return "Pai de Ouro";
    default:
      break;
  }
}


export const coinsList = [
  { codigo: "COP", nome: "PESO COLOMBIANO" },
  { codigo: "DKK", nome: "COROA DINAMARQUESA" },
  { codigo: "ZAR", nome: "RAND SUL-AFRICANO" },
  { codigo: "CAD", nome: "DÓLAR CANADENSE" },
  { codigo: "ILS", nome: "SHEKEL ISRAELENSE" },
  { codigo: "RUB", nome: "RUBLO RUSSO" },
  { codigo: "XAUUSD", nome: "OURO / ONÇA TROY 31.104" },
  { codigo: "CHF", nome: "FRANCO SUIÇO" },
  { codigo: "CNY", nome: "IUAN CHINÊS" },
  { codigo: "GBP", nome: "LIBRA ESTERLINA" },
  { codigo: "AED", nome: "DIRHAM DOS EMIRADOS ÁRABES" },
  { codigo: "CLP", nome: "PESO CHILENO" },
  { codigo: "AUD", nome: "DÓLAR AUSTRALIANO" },
  { codigo: "ARS", nome: "PESO ARGENTINO" },
  { codigo: "EUR", nome: "EURO" },
  { codigo: "NZD", nome: "DÓLAR NEOZELANDÊS" },
  { codigo: "MXN", nome: "PESO MEXICANO" },
  { codigo: "SEK", nome: "COROA SUECA" },
  { codigo: "JPY", nome: "IENE JAPONÊS" },
  { codigo: "PEN", nome: "SOL PERUANO" },
  { codigo: "OZ1D", nome: "OURO / BM&F (250g)" },
  { codigo: "UYU", nome: "PESO URUGUAIO" },
  { codigo: "USD", nome: "DÓLAR AMERICANO" },
  { codigo: "NOK", nome: "COROA NORUEGUESA" },
  { codigo: "MNG", nome: "MONEYGRAM" },
];


export const coinsListTravel = [
  { codMoeda: "VEB", nome: "BOLIVAR VENEZUELANO", selecionado: false },
  { codMoeda: "BOB", nome: "BOLIVIANO", selecionado: false },
  { codMoeda: "DKK", nome: "COROA DINAMARQUESA", selecionado: false },
  { codMoeda: "NOK", nome: "COROA NOROEGUESA", selecionado: false },
  { codMoeda: "SEK", nome: "COROA SUEKA", selecionado: false },
  { codMoeda: "AED", nome: "DIRHAM/EMIR.ARABE", selecionado: false },
  { codMoeda: "VTD", nome: "DOLAR - CARTÃO PRÉ-PAGO", selecionado: false },
  { codMoeda: "USD", nome: "DOLAR AMERICANO", selecionado: false },
  { codMoeda: "VTA", nome: "DOLAR AUSTRA - CARTÃO PRÉ-PAGO", selecionado: false },
  { codMoeda: "AUD", nome: "DOLAR AUSTRALIA", selecionado: false },
  { codMoeda: "CAD", nome: "DOLAR CANADA", selecionado: false },
  { codMoeda: "VTK", nome: "DOLAR CANADA - CARTÃO PRÉ-PAGO", selecionado: false },
  { codMoeda: "NZD", nome: "DOLAR NEOZELANDES", selecionado: false },
  { codMoeda: "VTZ", nome: "DOLAR NEOZELANDES | CARTÃO", selecionado: false },
  { codMoeda: "EUR", nome: "EURO", selecionado: false },
  { codMoeda: "VTE", nome: "EURO - CARTÃO PRÉ-PAGO", selecionado: false },
  { codMoeda: "CHF", nome: "FRANCO SUICO", selecionado: false },
  { codMoeda: "VTG", nome: "GBP LIBRA - CARTÃO PRÉ-PAGO", selecionado: false },
  { codMoeda: "GBP", nome: "GBP LIBRA ESTERLINA", selecionado: false },
  { codMoeda: "PYG", nome: "GUARANI/PARAGUAI", selecionado: false },
  { codMoeda: "JPY", nome: "IENE", selecionado: false },
  { codMoeda: "CNY", nome: "IUAN CHINES", selecionado: false },
  { codMoeda: "MNG", nome: "MONEY GRAM", selecionado: false },
  { codMoeda: "MMO", nome: "MORE PAYMENT", selecionado: false },
  { codMoeda: "TWD", nome: "NOVO DOLAR TAIWANES", selecionado: false },
  { codMoeda: "AUA", nome: "Ouro App", selecionado: false },
  { codMoeda: "AU", nome: "OURO ATIVO FINANCEIRO", selecionado: false },
  { codMoeda: "AUM", nome: "Ouro Barra OM", selecionado: false },
  { codMoeda: "AUO", nome: "Ouro Barra Outros", selecionado: false },
  { codMoeda: "AUC", nome: "Ouro Cartão Person.", selecionado: false },
  { codMoeda: "AUP", nome: "Ouro Cartão Piramide", selecionado: false },
  { codMoeda: "AUT", nome: "Ouro Cartão Tematico", selecionado: false },
  { codMoeda: "AUJ", nome: "Ouro Joias", selecionado: false },
  { codMoeda: "AUL", nome: "Ouro Laminado", selecionado: false },
  { codMoeda: "AUS", nome: "Ouro Stargold", selecionado: false },
  { codMoeda: "PEN", nome: "PERU NOVO SOL", selecionado: false },
  { codMoeda: "ARS", nome: "PESO ARGENTINO", selecionado: false },
  { codMoeda: "CLP", nome: "PESO CHILENO", selecionado: false },
  { codMoeda: "MXN", nome: "PESO MEXICANO", selecionado: false },
  { codMoeda: "UYU", nome: "PESO URUGUAIO", selecionado: false },
  { codMoeda: "COP", nome: "PESO/COLOMBIA", selecionado: false },
  { codMoeda: "ZAR", nome: "RANDE SUL AFRICANO", selecionado: false },
  { codMoeda: "QAR", nome: "RIAL CATARENSE", selecionado: false },
  { codMoeda: "RUB", nome: "RUBLE RUSSIAN", selecionado: false },
  { codMoeda: "ILS", nome: "SHEKEL / ISRAEL", selecionado: false }
];
